import { useCallback, useEffect, useRef, useState } from "react";

function useInterval(callback: () => void, delay: number) {
    const intervalRef = useRef<number | null>(null);
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        const tick = () => callbackRef.current();

        intervalRef.current = window.setInterval(tick, delay);

        return () => {
            if (intervalRef.current != null) {
                window.clearInterval(intervalRef.current);
            }
        };
    }, [delay]);

    return intervalRef;
}

export { useInterval };
